import React from 'react';

const ActionButtons = ({
	onSubmit,
	onReCost,
	hasChanges,
	isEditable = true,
	hasSubmittedCosting = false
}) => {
	return (
		<div className="costing-summary-bottom border mt-3 p-3">
			{isEditable ? (
				hasChanges ? (
					<button className="button size32 w-100" onClick={onReCost}>
						<span className="regular-14 weight-500">Re-Cost</span>
					</button>
				) : (
					<button className="button size32 w-100" onClick={onSubmit} disabled={hasSubmittedCosting}>
						<span className="regular-14 weight-500">Submit</span>
					</button>
				)
			) : null}
		</div>
	);
};

export default ActionButtons;
